module.exports = __webpack_public_path__ + "img/marker-driver.3f1bbfec.png";